import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon } from 'lucide-react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { usePlatform } from '../../context/PlatformContext';
import { handleImgError } from '../../utils/imageUtils';
export const VendorCTASection: React.FC = () => {
  const dk = useDarkClasses();
  const {
    isAfterTide
  } = usePlatform();
  const ctaTitle = isAfterTide ? 'Write dark fiction?' : 'Are you an indie author?';
  const ctaDescription = isAfterTide ? 'Join AfterTide to reach readers who crave boundary-pushing stories. Our tier system ensures your work finds the right audience.' : 'Join LitLaunch to showcase your books and merchandise to thousands of dedicated readers who love indie stories.';
  const ctaFeatures = isAfterTide ? ['Transparent tier-based classification', 'Reach readers who want dark content', 'Detailed consent and content warning tools'] : ['Sell all book formats in one place', 'Create and sell official merchandise', 'Promote your events and connect with fans'];
  const ctaGradient = isAfterTide ? 'bg-gradient-to-r from-[#2d1b3d] to-[#1a1a2e]' : 'bg-gradient-to-r from-indigo-500 to-indigo-700';
  const ctaButtonClass = isAfterTide ? 'bg-[#e2b04a] text-[#1a1a2e] hover:bg-[#d1a03a]' : 'bg-white text-indigo-700 hover:bg-indigo-50';
  return <section className={`py-16 ${dk.page}`} data-id="element-1891" data-mp="15f1ijivijh2m">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1892" data-mp="10f6qhc004lfz">
        <div className={`${ctaGradient} rounded-2xl shadow-xl overflow-hidden`} data-id="element-1893" data-mp="10gzx4ram75nz">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-1894" data-mp="1fd7hbrm0w739">
            <div className="p-8 md:p-12 text-white flex flex-col justify-center" data-id="element-1895" data-mp="1admev77n9gls">
              <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1896" data-mp="1afpdgfmv4i24">
                {ctaTitle}
              </h2>
              <p className="text-lg opacity-90 mb-8 max-w-lg" data-id="element-1897" data-mp="2lsrwdhcfpjpg">
                {ctaDescription}
              </p>

              {/* Stats Row */}
              <div className="grid grid-cols-3 gap-4 mb-8 py-6 border-y border-white/20" data-id="element-1898" data-mp="2sv6jyxhtm68l">
                <div className="text-center" data-id="element-1899" data-mp="2xtht160akcpr">
                  <div className="text-2xl font-black" data-id="element-1900" data-mp="32tw3svta20rh">
                    {isAfterTide ? '200+' : '500+'}
                  </div>
                  <div className="text-xs uppercase tracking-wider opacity-80 mt-1" data-id="element-1901" data-mp="37t8qngk5f7u2">
                    Authors
                  </div>
                </div>
                <div className="text-center border-x border-white/20" data-id="element-1902" data-mp="2a3dp0xj6yay8">
                  <div className="text-2xl font-black" data-id="element-1903" data-mp="2f4t9oohgifg3">
                    {isAfterTide ? '25K+' : '50K+'}
                  </div>
                  <div className="text-xs uppercase tracking-wider opacity-80 mt-1" data-id="element-1904" data-mp="2k1jtnmwdtv6s">
                    Readers
                  </div>
                </div>
                <div className="text-center" data-id="element-1905" data-mp="1rdxle1c7m2dl">
                  <div className="text-2xl font-black" data-id="element-1906" data-mp="1wdtsi9g7e9xd">
                    {isAfterTide ? '5K+' : '10K+'}
                  </div>
                  <div className="text-xs uppercase tracking-wider opacity-80 mt-1" data-id="element-1907" data-mp="diyz7yquab92">
                    Titles
                  </div>
                </div>
              </div>

              <ul className="space-y-3 mb-8" data-id="element-1908" data-mp="4hr57svcvwks">
                {ctaFeatures.map(item => <li key={item} className="flex items-center" data-id="element-1909" data-mp="3vokg5ofyba2i">
                    <div className={`${isAfterTide ? 'bg-[#e2b04a]/20 text-[#e2b04a]' : 'bg-white/20 text-white'} rounded-full p-1 mr-3`} data-id="element-1910" data-mp="3vo2da8ys9xlm">
                      <CheckCircleIcon className="h-4 w-4" data-id="element-1911" data-mp="3lwxx55xdg6p7" />
                    </div>
                    <span className="font-medium" data-id="element-1912" data-mp="3hxys7lbn49xr">{item}</span>
                  </li>)}
              </ul>
              <div data-id="element-1913" data-mp="3cznlhjgn6fjr">
                <Link to="/vendor/signup" className={`inline-block font-bold px-8 py-4 rounded-lg transition-colors shadow-lg ${ctaButtonClass}`} data-id="element-1914" data-mp="3cvzpmdnq5h1v">
                  {isAfterTide ? 'Start Publishing on AfterTide' : 'Start Selling Today'}
                </Link>
              </div>
            </div>
            <div className="hidden lg:flex flex-col" data-id="element-1915" data-mp="1bxo1ia5riwcf">
              <div className="h-2/3 relative" data-id="element-1916" data-mp="x7gqgfi34flr">
                <img src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Author writing" className="absolute inset-0 h-full w-full object-cover" onError={handleImgError} data-id="element-1917" data-mp="x4m8qvqgh8w1" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" data-id="element-1918" data-mp="e82vpvcj70u7"></div>
              </div>
              <div className="h-1/3 bg-black/40 backdrop-blur-sm p-8 flex items-center justify-center" data-id="element-1919" data-mp="j7p9q706ol42">
                <blockquote className="text-white max-w-md" data-id="element-1920" data-mp="28mdk62p7rszg">
                  <p className="text-lg italic mb-4" data-id="element-1921" data-mp="2dlgr5sor89a2">
                    "
                    {isAfterTide ? 'AfterTide gave my dark fiction a home where readers actually seek it out. The tier system is a game-changer.' : "LitLaunch helped me reach 5,000 new readers in my first month. It's the platform indie authors have been waiting for."}
                    "
                  </p>
                  <footer className="flex items-center" data-id="element-1922" data-mp="6vwn5hwwjtaq">
                    <div className="w-10 h-10 rounded-full bg-gray-300 overflow-hidden mr-3 border-2 border-white/20" data-id="element-1923" data-mp="kntal8nmlf0s">
                      <img src="https://i.pravatar.cc/100?img=44" alt="Author" className="w-full h-full object-cover" data-id="element-1924" data-mp="gn9ca1rbg5d2" />
                    </div>
                    <div data-id="element-1925" data-mp="pnz3es5mt7kg">
                      <div className="font-bold text-sm" data-id="element-1926" data-mp="2wdm6m0omew6c">
                        {isAfterTide ? 'R. Blackwell' : 'Sarah J.'}
                      </div>
                      <div className="text-xs opacity-70" data-id="element-1927" data-mp="2rg3trz7hfwt2">
                        {isAfterTide ? 'Dark Romance Author' : 'Romance Author'}
                      </div>
                    </div>
                  </footer>
                </blockquote>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};